import { Box, BoxProps } from '@mui/material';
import React from 'react';


export type NavigationSectionProps = {
  alignment?: 'start' | 'center' | 'end';
  vertical?: 'stretch' | 'center';
} & BoxProps;


export const NavigationSection: React.FC<NavigationSectionProps> = ({ alignment = 'start', vertical = 'stretch', children, ...props }) => {
  const justifyContent = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
  }[alignment];

  const alignItems = {
    stretch: 'stretch',
    center: 'center',
  }[vertical];

  return (
    <Box
      display="flex"
      alignItems={alignItems}
      justifyContent={justifyContent}
      flex={1}
      gap="14px"
      alignSelf="stretch"
      {...props}
    >
      {children}
    </Box>
  );
};
